export default function navigateDeepLink(url: string) {
  window.location.assign(url);
}
